import { DesktopCapturer } from 'electron';
import { Injectable } from '@angular/core';

import {
    START_NOTIFICATION_SERVICE,
    NOTIFICATION_SERVICE_STARTED,
    NOTIFICATION_SERVICE_ERROR,
    NOTIFICATION_RECEIVED,
    TOKEN_UPDATED,
} from 'electron-push-receiver/src/constants'

declare let window: any;

@Injectable({
    providedIn: 'root'
})
export class ElectronRef {

    private _electron: any;

    private get electron(): any {

        if (!this._electron) {
            try {
                this._electron = window.require && window.require('electron');
            } catch (e) {
                return null;
            }
        }

        return this._electron;
    }

    // IpcRenderer
    get ipc() {
        return this.electron && this.electron.ipcRenderer;
    }

    // DesktopCapturer
    get desktopCapturer(): DesktopCapturer {
        return this.electron && this.electron.desktopCapturer;
    }

    // Remote
    get remote(): any {
        return this.electron && this.electron.remote;
    }

    /**
     *  display Desktop Notification
     *
     * @param title: string
     * @param message: string
     * @param onClick: void
     */
    openNotify(title: string, message: string, onClick?: () => void) {
        const notification = new Notification(title, {
            body: message
        });

        notification.onclick = onClick;
    }

    /**
     * display a progress bar to a taskbar button/ or dock icon
     *
     * @param value: number (0 ~ 1)
     */
    setProgressBar(value: number) {

        if (this.ipc) {
            this.ipc.send('set-progressbar', value);
        }
    }

    checkForUpdates() {

    }

    getIpAddress() {
        return this.ipc.sendSync('get-local-ip');
    }

    resizeWindow(width: number, height: number) {
        if (this.ipc) {
            this.ipc.send('resize-window', width, height);
        }
    }

    // This file is required by the index.html file and will
    // be executed in the renderer process for that window.
    // All of the Node.js APIs are available in this process.

    // const { ipcRenderer } = require('electron')
    // import {
    //     START_NOTIFICATION_SERVICE,
    //     NOTIFICATION_SERVICE_STARTED,
    //     NOTIFICATION_SERVICE_ERROR,
    //     NOTIFICATION_RECEIVED,
    //     TOKEN_UPDATED,
    // }  from 'electron-push-receiver/src/constants'
    initBadge() {
        console.log('this.electron', this.electron);
        if (this.ipc == null)
            return;
        let ipcRenderer = this.ipc;

        // Add the event listener for the response from the main process
        ipcRenderer.on('mainprocess-response', (event, arg) => {
            console.log(arg); // prints "Hello World!"
        });

        ipcRenderer.send('request-mainprocess-action', { badge: 0 });
    }
    initNotifications() {
        console.log("initNotifications", this.ipc == null);
        if (this.ipc == null)
            return;
        let ipcRenderer = this.ipc;
        // Listen for service successfully started
        ipcRenderer.on(NOTIFICATION_SERVICE_STARTED, (_, token) => {
            console.log('service successfully started', token)
        })

        // Handle notification errors
        ipcRenderer.on(NOTIFICATION_SERVICE_ERROR, (_, error) => {
            console.log('notification error', error)
        })

        // Send FCM token to backend
        ipcRenderer.on(TOKEN_UPDATED, (_, token) => {
            console.log('token updated', token)
        })

        // Display notification
        ipcRenderer.on(NOTIFICATION_RECEIVED, (_, serverNotificationPayload) => {
            // check to see if payload contains a body string, if it doesn't consider it a silent push
            if (serverNotificationPayload.notification.body) {
                // payload has a body, so show it to the user
                console.log('display notification', serverNotificationPayload)
                let myNotification = new Notification(serverNotificationPayload.notification.title, {
                    body: serverNotificationPayload.notification.body
                })

                ipcRenderer.send('request-mainprocess-action', { badge: 1 });
                myNotification.onclick = () => {
                    console.log('Notification clicked')

                    ipcRenderer.send('request-mainprocess-action', { badge: 0 });
                }
            } else {
                // payload has no body, so consider it silent (and just consider the data portion)
                console.log('do something with the key/value pairs in the data', serverNotificationPayload.data)
            }
        })

        // Start service
        const senderId = '517477192351' // <-- replace with FCM sender ID from FCM web admin under Settings->Cloud Messaging
        console.log('starting service and registering a client')
        ipcRenderer.send(START_NOTIFICATION_SERVICE, senderId)



    }

}

